/**
 * Persistent footer rendered below the main outlet on every page
 * inside :class:`AppShell`.
 *
 * Shows copyright + the build-time portal version, mirroring the
 * pharmaforge and orbit portal footers (#388 in pharmaforge). The
 * ``flowstack-`` tag prefix is stripped so the footer reads
 * ``… · FlowStack v0.9.0`` rather than
 * ``… · FlowStack flowstack-v0.9.0``. Local ``pnpm build``s without
 * the env var fall back to ``"dev"``.
 *
 * Since #953 it is the last child of the WORKSPACE column rather than
 * of the shell root, so its rule starts where the full-height rail
 * ends instead of running under it — and it is deliberately thin
 * ("a tiny space on bottom", the operator's words): ``py-1.5`` at
 * ``text-xs``, roughly half its previous height. It stays a sibling of
 * ``<main>``, never a child, so it is still the page's
 * ``contentinfo``; :file:`AppShell.tsx` carries the why.
 */
export function Footer() {
  const version = (import.meta.env.VITE_APP_VERSION ?? "dev").replace(/^flowstack-/, "");
  return (
    <footer className="flex-shrink-0 border-t border-border-subtle px-6 py-1.5 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} ATTMOS Inc. All rights reserved. · FlowStack {version}
    </footer>
  );
}
